import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./SurveyModal.css";

function MultiSelect({title, options, question, saveAnswer, lng, isEng}) {

  const { t } = useTranslation();
  

  const [selectedReasonsMultiple, setSelectedReasonsMultiple] = useState([]);
  const handleCheckboxChangeMultiple = (reason) => {
    console.log(reason,selectedReasonsMultiple,'reason')
    setSelectedReasonsMultiple((prevSelected) =>
      prevSelected.includes(reason)
        ? prevSelected.filter((item) => item !== reason)
        : [...prevSelected, reason]
    );
  };

    // ✅ This gets the most up-to-date version of selectedReasonsMultiple
    useEffect(() => {
      if(selectedReasonsMultiple?.length > 0) {
        saveAnswer(question.QuestionID, 4, selectedReasonsMultiple);
      }
    }, [selectedReasonsMultiple, question.QuestionID]);

  return(
    <div className="survey_common_style_start_col">
      <div className="survey_margin_top_and_bottom_page2">
        <div style={lng === "arab" ? { direction: "rtl" } : null} className="survey_margin_bottom">
          {title ?? '-'}
          <span style={{ color: "#D3D3D3" }}>({t("optional")})</span>
        </div>

        {options?.map((reason, index) => {
          const optionLabel = isEng ? reason?.AnswerTitleE : reason?.AnswerTitleA;
          return (
            <label className="custom-checkbox" key={index}>
              <input
                type="checkbox"
                checked={selectedReasonsMultiple.includes(reason)}
                onChange={() => handleCheckboxChangeMultiple(reason) }
              />
              <span className="checkmark"></span>
              <span style={lng === "arab" ? { direction: "rtl" } : null}>{optionLabel ?? '-'}</span>
            </label>
          )

        })}
      </div>


    </div>
  
  )


}

export default MultiSelect;